import { render, staticRenderFns } from "./ExamDonutChart.vue?vue&type=template&id=0a5acd5b&scoped=true"
import script from "./ExamDonutChart.vue?vue&type=script&lang=js"
export * from "./ExamDonutChart.vue?vue&type=script&lang=js"
import style0 from "./ExamDonutChart.vue?vue&type=style&index=0&id=0a5acd5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5acd5b",
  null
  
)

export default component.exports